import React from 'react';
import VideoEmbed from '../VideoEmbed';
import { LessonBlock } from '../types';

// Renders the grid video, the intro line and the icon pairs — and deliberately
// NOT block.items. featureGrid blocks carry the same content in both `pairs` and
// `items`; the design prototype renders only `pairs`, so rendering items too
// prints every pair a second time as plain text.
export default function FeatureGrid({ block }: { block: LessonBlock }) {
  return (
    <>
      {block.hasGridVideo && <VideoEmbed url={block.gridVideoEmbed || ''} />}
      {block.whyIntro && <p className="pc-lesson-p">{block.whyIntro}</p>}
      <div className="pc-lesson-features">
        {(block.pairs || []).map((pair, i) => (
          /* eslint-disable-next-line react/no-array-index-key */
          <article className="pc-lesson-feature" key={i}>
            <span className="pc-lesson-feature-icon" aria-hidden="true">{pair.icon || 'check'}</span>
            <div>
              <h3 className="pc-lesson-feature-title">{pair.title}</h3>
              <p className="pc-lesson-p">{pair.body}</p>
            </div>
          </article>
        ))}
      </div>
    </>
  );
}
